import { render, staticRenderFns } from "./autoevaluation.vue?vue&type=template&id=a503534a&scoped=true"
import script from "./autoevaluation.vue?vue&type=script&lang=js"
export * from "./autoevaluation.vue?vue&type=script&lang=js"
import style0 from "./autoevaluation.vue?vue&type=style&index=0&id=a503534a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a503534a",
  null
  
)

export default component.exports